import pino from 'pino';

const logger = pino({
  // https://github.com/pinojs/pino/blob/main/docs/api.md#options-object
  level: 'info',
  transport: {
    target: 'pino-pretty',
    options: {
      colorize: true,
    },
  },
});

export default logger;
